import { Pipe, PipeTransform } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Pipe({
	name: 'secure',
})
export class SecureImagePipe implements PipeTransform {
	constructor(
		private http: HttpClient,
		private sanitizer: DomSanitizer
	) {}

	transform(url: string): Observable<SafeUrl> {
		return this.http.get(url, { responseType: 'blob' }).pipe(
			map((val) => {
				// We could look into release the brwoser memory via URL.revokeObjectURL,
				// but given an maximum or around 4.5mb for all logos it was deemed not
				// worth the effort
				return this.sanitizer.bypassSecurityTrustUrl(
					URL.createObjectURL(val)
				);
			}),
			catchError((error) => {
				if (error.status === 404) {
					return of(`/assets/search/PlaceholderLogo.svg`);
				}
				throw error;
			})
		);
	}
}
